<h1>Insurance Groups</h1>
<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a mat-tab-link (click)="gotoTab(link.link)"
    [active]="activeLink == link">{{link.title}}</a>
  }
</nav>
@if (activeLink?.title === 'Products') {
  <app-vendor-groups-products></app-vendor-groups-products>
}
@if (activeLink?.title === 'Plans') {
  <app-vendor-groups-plans></app-vendor-groups-plans>
}
@if (activeLink?.title === 'Rates') {
  <app-vendor-groups-rates></app-vendor-groups-rates>
}
@if (activeLink?.title === 'Questions') {
  <app-vendor-groups-questions></app-vendor-groups-questions>
}
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
